import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	editButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	editButton: {
		id: 'bulk-operations-core.toolbar.use-edit-action.edit-button',
		defaultMessage: 'Edit fields',
		description:
			'The text will be shown inside a button in a toolbar to allow the the user to edit the selected issues.',
	},
});
